import axiosInstance from "../Services/Api/axiosInstance"

export const fetchPolicies = async () => {
    try {
        const response = await axiosInstance.get("/policies");

        return response.data.data;
    }
    catch (error) {
        throw new Error("Error fetching policies");
    }
};

// PoliciesApi.js
export const fetchPolicyDocument = async (id) => {
    try {
        const response = await axiosInstance.get(`/policies/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error fetching policy details");
    }
};

export const acknowledgePolicyDocument = async (id) => {
    try {
        const response = await axiosInstance.get(`/policies/acknowledgement/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error acknowledging policy");
    }
};